{
	"postTrading": {
		"info": {
			"titles": {
				"OPEXP": "Option Expiration",
				"OPEXC": "Option Execution",
				"OPASN": "Obligation Calculation"
			},
			"status": "Status",
			"date": "Date",
			"ticker": "Ticker",
			"qtyContracts": "Contracts Quantity",
			"side": "Order Side",
			"asset": "Asset",
			"qty": "Quantity",
			"price": "Price",
			"sum": "Amount",
			"completed": "Completed",
			"sides": {
				"call": "Buy",
				"put": "Sell"
			},
			"assetsInfoFailed": "Failed to load option asset info"
		}
	}
}
